<div style="display: flex;align-items: end;flex-direction:column;">
    <button nz-button
            (click)="nzModalRef.close()"
            nz-wave
            style="position: absolute;"
            [routerLink]="'/🏠/🔑'"
            nzType="primary"
            nzDanger
            nzShape="circle"
            nzSize="small"><nz-icon nzType="close" />
    </button>
</div>
<div class="ui small header m-1">
    Bayrak Düzenle
</div>


<div class="scrolling content p-3 m-0 overflow-y-auto overflow-x-hidden">



    <div class="description"
         style="display: flex;">
        <!-- NOT: Orta Sol Bölme Bayrak Kurdela Bölgesi -->
        <div style="width: 35px;margin-right: 5px;">
            <div class="buyut hover:buyut-1 active:buyut-1"
                 [style.background]="bayrak?.renkArka ?? 'blue'"
                 [style.color]="bayrak?.renkYazi ?? 'white'"
                 style="display: flex;align-items: center;justify-content: center;width: 35px;height: 35px;background: blue;font-size: 0.75rem;color:white;overflow: hidden;text-align: center;border-radius: 3px;">
                {{bayrak?.baslik ?? "FikoYT"}}
            </div>
        </div>
        <!-- NOT:  Orta Sağ Bölme Text Editor vs. -->
        <div style="flex: 1;">

            <!-- NOT:  İçerik Sayfalama -->
            <div style="display: flex;row-gap: 5px;"
                 class="w-full flex-1 flex-column">

                <nz-input-wrapper nzPrefix="🖋"
                                class="w-full"
                                nzSize="small">
                    <input type="text" [(ngModel)]="bayrak.baslik" [ngModelOptions]="{standalone: true}"  nz-input placeholder="Bayrak Başlığı" />
                </nz-input-wrapper>
                <div style="display: flex;justify-content: space-between;">
                    <span style="display: flex;align-items: center;">
                        <nz-color-picker [(ngModel)]="bayrak.renkArka" [ngModelOptions]="{standalone: true}" nzSize="small"></nz-color-picker>
                        Arka Renk
                    </span>
                    <span style="display: flex;align-items: center;">
                        Yazı Rengi
                        <nz-color-picker [(ngModel)]="bayrak.renkYazi" [ngModelOptions]="{standalone: true}" nzSize="small"></nz-color-picker>
                    </span>
                </div>

                <nz-input-wrapper nzPrefix="✏️"
                                class="flex-1 w-full prefix-ustte"
                                title="Bayrak Açıklaması">
                    <textarea placeholder="Bayrak Açıklaması"
                              class="p-0"
                              nz-input
                              [(ngModel)]="bayrak.aciklama" [ngModelOptions]="{standalone: true}" 
                              type="text"
                              [rows]="3"></textarea>
                </nz-input-wrapper>
            </div>

        </div>

    </div>


    <div class="mt-3"
         style="display: flex;align-items: end;flex-direction:row;">

        <div class="ui right red labeled animated fade icon button mini"
             (click)=" this.nzModalRef?.destroy();"
             style="vertical-align: top;">
            <div class="visible content">
                Kapat
            </div>
            <div class="hidden content">
                Kapat
            </div>
            <i class="close icon"></i>
        </div>
        <span style="flex: 1;"></span>
        <div class="ui green labeled animated fade icon button mini"
             (click)="kaydetTiklandi()"
        
             style="vertical-align: top;">
            <div class="visible content">
                Kaydet
            </div>
            <div class="hidden content">
                Kaydet
            </div>
            <i class="check icon"></i>
        </div>
    </div>